/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card } from "@mui/material";
import CategoryData from "layouts/tables/data/categoryTableData";
import { getJobType } from "api";
import { useEffect, useState } from "react";

function Category() {
  const { sales, tasks } = reportsLineChartData;

  const CategoryLists = () => {
    return (
      <MDBox p={0}>
        <CategoryData></CategoryData>
      </MDBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title="Job Category" />
      <MDBox py={3}>
        <CategoryLists />
      </MDBox>
      <MDBox mb={2} />
      <Footer />
    </DashboardLayout>
  );
}

export default Category;
